import { getAddress } from "viem"

export const vaults = new Map([
  [
    getAddress("0xB615D3123410EE89542b027DC71e87b4Fc05EA80"),
    {
      name: "Re7 Labs SolvBTC.BBN",
      description: "Component of the Re7 Labs BOB Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x33Cc3800574c4bEe6D7428e707Db82d1543d639D"),
    {
      name: "Re7 Labs SolvBTC",
      description: "Component of the Re7 Labs BOB Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x11DA346d3Fdb62641BDbfebfd54b81CAA871aEf6"),
    {
      name: "Re7 Labs WBTC",
      description: "Component of the Re7 Labs BOB Cluster",
      entity: "re7-labs",
    },
  ],
])
